import styled, { css, keyframes } from 'styled-components';

const glow = keyframes`
    0%,
    100% {
        box-shadow: 0 0 0 rgba(75, 124, 243, 0);
    }
    50% {
        box-shadow: 0 0 8px rgba(75, 124, 243, 0.45);
    }
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 20px;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const CTAButton = styled.button`
    ${({ theme }) => css`
        display: inline-flex;
        align-items: center;
        height: 32px;
        gap: 6px;
        border: none;
        cursor: pointer;
        padding: 0 18px;
        border-radius: ${theme.borderRadius.default};
        font-size: 12px;
        line-height: 1;
        font-weight: 600;
        white-space: nowrap;
        color: ${theme.colors.white};
        background: linear-gradient(
            100deg,
            ${theme.colors.accentColor} 0%,
            ${theme.colors.secondaryColor} 100%
        );
        animation: ${glow} 2.6s ease-in-out infinite;
        transition: transform 0.15s ease, filter 0.15s ease;

        &:hover {
            filter: brightness(1.08);
            animation-play-state: paused;
        }

        &:active {
            transform: scale(0.98);
        }

        svg {
            width: 13px;
            height: 13px;
            flex: none;
        }
    `}
`;
